import './newRelicBrowserAgent';

import React from 'react';

import '@ifeel-online/storybook/dist/themes/DefaultTheme.css';
import {createRoot} from 'react-dom/client';

import './customPreflight.css';
import App from './App';
import './index.css'; /*Anything written in the project will have more importance than imported From SB*/
import './i18n';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);
